import { useLocation } from "react-router-dom";
import { authLinks, links } from "./Navbar.links";
import { useAuthContext } from "../Auth";

export const useNavbar = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuthContext();

  const currentPathname = location?.pathname;

  return { links: isAuthenticated ? authLinks : links, currentPathname };
};
